import { useContext } from 'react';
import {
	LatestProcessRequestExecutionStateMonitorContext,
	LatestProcessRequestExecutionStateMonitorContextValue,
} from '@app/site/secured/rateshopper/rates/provider/LatestProcessRequestExecutionStateMonitorProvider';

export const useLatestProcessRequestExecutionStateMonitor = (): LatestProcessRequestExecutionStateMonitorContextValue => {
	return useContext(LatestProcessRequestExecutionStateMonitorContext);
};
